import React, { Component } from "react";
import Constants from "Helpers/Constants";
import axios from "axios";
import init from "Helpers/WindowToken";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { Navigate } from "react-router-dom";

import { Card, Grid, InputLabel, MenuItem, Select, TextField } from "@mui/material";

import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDButton from "components/MDButton";

export default class UpdateNavbarText extends Component {
  state = {
    itemId: "",
    title: "",
    link: "",
    status: "active",
    is_delete: "no",

    loading: false,
    notification: false,
    message: "",
    notiColor: "success",
    redirect: false,
  };

  componentDidMount() {
    this.getItem();
  }

  getItem = () => {
    if (init() !== "success") {
      window.location.assign("/signin");
      return;
    }
    const id = window.location.pathname.split("/")[2];
    axios
      .get(Constants.getUrls.getAllNavbarTexts + "/" + id)
      .then((resp) => {
        if (resp.data?.status === "success") {
          const d = resp.data.data || {};
          this.setState({
            itemId: d._id,
            title: d.title || "",
            link: d.link || "",
            status: d.status || "active",
            is_delete: d.is_delete || "no",
          });
        } else {
          this.setState({
            notification: true,
            notiColor: "warning",
            message: resp.data?.message || "Failed to fetch",
          });
        }
      })
      .catch((err) =>
        this.setState({
          notification: true,
          notiColor: "warning",
          message: err?.response?.data?.message || "Error fetching",
        })
      );
  };

  handleInput = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { itemId, title, link, status, is_delete } = this.state;

    if (!title) {
      this.setState({ notification: true, notiColor: "warning", message: "Title is required!" });
      setTimeout(() => this.setState({ notification: false, message: "" }), 2200);
      return;
    }

    if (init() !== "success") {
      window.location.assign("/signin");
      return;
    }

    const body = { title, link: link || "", status, is_delete };
    this.setState({ loading: true });

    axios
      .put(Constants.putUrls.updateNavbarText + itemId, body)
      .then((resp) => {
        this.setState({
          notification: true,
          notiColor: "success",
          message: resp.data?.message || "Updated!",
          loading: false,
        });
        setTimeout(() => this.setState({ notification: false, message: "", redirect: true }), 1400);
      })
      .catch((err) => {
        this.setState({
          notification: true,
          notiColor: "warning",
          message: err?.response?.data?.message || "Update failed",
          loading: false,
        });
        setTimeout(() => this.setState({ notification: false, message: "" }), 3500);
      });
  };

  render() {
    if (this.state.redirect) return <Navigate to="/navbartexts" />; // adjust if needed

    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                Update Navbar Text
              </MDTypography>
            </MDBox>

            <MDBox py={3} px={2}>
              <form onSubmit={this.handleSubmit}>
                <Grid container spacing={2}>
                  <Grid item sm={12}>
                    <TextField
                      label="Title"
                      name="title"
                      value={this.state.title}
                      onChange={this.handleInput}
                      style={{ width: "100%" }}
                    />
                  </Grid>

                  <Grid item sm={12}>
                    <TextField
                      label="Link (optional)"
                      name="link"
                      value={this.state.link}
                      onChange={this.handleInput}
                      placeholder="/about or https://example.com"
                      style={{ width: "100%" }}
                    />
                  </Grid>

                  <Grid item sm={6}>
                    <InputLabel>Status</InputLabel>
                    <Select
                      name="status"
                      value={this.state.status}
                      onChange={(e) => this.setState({ status: e.target.value })}
                      style={{ width: "100%", height: 45 }}
                    >
                      <MenuItem value="active">Active</MenuItem>
                      <MenuItem value="inactive">Inactive</MenuItem>
                    </Select>
                  </Grid>

                  <Grid item sm={6}>
                    <InputLabel>Is Delete</InputLabel>
                    <Select
                      name="is_delete"
                      value={this.state.is_delete}
                      onChange={(e) => this.setState({ is_delete: e.target.value })}
                      style={{ width: "100%", height: 45 }}
                    >
                      <MenuItem value="no">No</MenuItem>
                      <MenuItem value="yes">Yes</MenuItem>
                    </Select>
                  </Grid>

                  <Grid item sm={12}>
                    <MDButton variant="contained" size="small" color="info" type="submit">
                      {this.state.loading ? "Updating..." : "Update"}
                    </MDButton>
                  </Grid>
                </Grid>
              </form>
            </MDBox>

            <MDSnackbar
              color={this.state.notiColor}
              icon="notifications"
              title="Navbar Texts Admin"
              content={this.state.message}
              dateTime="Just now"
              open={this.state.notification}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}
